import { useContext, useMemo } from 'react';
import { CHAVE_ORG_GUARDADA, OrganizationContext, useOrganization } from '@/contexts/OrganizationContext';
import { getOrgPreset, getRememberedOrgPreset, type OrgPreset } from '@/lib/orgPresets';

/** Preset de interface da org atual, ou `null` para o Vertto padrão. */
export function useOrgPreset(): OrgPreset | null {
  const { currentOrg } = useOrganization();
  const uiPreset = currentOrg?.ui_preset ?? null;
  return useMemo(() => getOrgPreset(uiPreset), [uiPreset]);
}

/**
 * Preset para as telas de carregamento. Com a org carregada, é o dela. Antes disso, é o palpite
 * da última visita (ver `getRememberedOrgPreset`). Não lança fora do OrganizationProvider.
 */
export function useLoadingPreset(): OrgPreset | null {
  const ctx = useContext(OrganizationContext);
  const currentOrg = ctx?.currentOrg ?? null;
  const uiPreset = currentOrg?.ui_preset ?? null;
  return useMemo(() => {
    if (currentOrg) return getOrgPreset(uiPreset);
    let orgIdToOpen: string | null = null;
    try {
      orgIdToOpen = localStorage.getItem(CHAVE_ORG_GUARDADA);
    } catch {
      orgIdToOpen = null;
    }
    return getRememberedOrgPreset(orgIdToOpen);
  }, [currentOrg, uiPreset]);
}
